"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.length = void 0;
const config_1 = require("../config");
const utils_1 = require("./utils");
function length(lengthValue, { message } = config_1.default.validators.length) {
    return (0, utils_1.makeValidator)({
        predicate: value => value.length === lengthValue,
        message: message.replace(':length', lengthValue.toString())
    });
}
exports.length = length;
